<template>
  <div
    class="p-card"
    :class="{'p-card--transparent': transparent}"
  >
    <div
      v-if="hasHeader"
      class="p-card__header"
      :class="{
        'p-card__header--with-action-bar': hasActionBar,
        'p-card__header--with-description': hasDescription
      }"
    >
      <slot name="header">
        <div class="p-card__title">
          <slot name="title">
            <div
              class="el-text el-text--display-regular el-text--ellipsis"
              :class="[ title ? `qa-text-${qaClassTitle}`: '' ]"
              :data-test-id="`card.title-${qaClassTitle}`"
            >
              {{ title }}
            </div>
          </slot>
          <div
            v-if="hasTip"
            class="p-card__tip"
          >
            <slot name="tip" />
          </div>
        </div>
        <div
          v-if="hasActionBar"
          class="p-card__action-bar"
        >
          <slot name="action-bar" />
        </div>
      </slot>
    </div>
    <div
      v-if="hasDescription"
      class="p-card__description"
      data-test-id="card.descrption"
    >
      <slot name="description">
        <div class="el-text el-text--body-24">
          {{ description }}
        </div>
      </slot>
    </div>
    <div
      v-if="hasContent"
      class="p-card__content"
      :class="{
        'p-card__content--with-divider': hasHeader
      }"
    >
      <slot />
    </div>
    <div
      v-if="hasFooter"
      class="p-card__footer"
    >
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    transparent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasHeader() {
      return this.title || this.hasTip || this.hasActionBar || this.hasDescription;
    },
    hasTip() {
      return !!this.$slots.tip;
    },
    hasActionBar() {
      return !!this.$slots['action-bar'];
    },
    hasDescription() {
      return !!this.description;
    },
    hasContent() {
      return !!this.$slots.default;
    },
    qaClassTitle() {
      return this.title.replace(/\s+/g, '');
    },
    hasFooter() {
      return !!this.$slots.footer;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@uikit/ui-kit/themes/acronis/src/common/variables';

.p-card {
  border: $av-border-sm $av-brand-accent;
  border-radius: $av-border-radius-2;
  background-clip: padding-box;
  background-color: $av-fixed-white;
  overflow: hidden;

  &--transparent {
    background-color: transparent;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px;

    &--with-action-bar {
      padding: 12px 16px 12px 24px;
    }

    &--with-description {
      padding: 16px 24px 8px 24px;
    }

    &--with-action-bar.p-card__header--with-description {
      padding: 12px 16px 8px 24px;
    }
  }

  &__title {
    display: flex;
    min-width: 0;
  }

  &__tip {
    margin-left: 8px;
  }

  &__action-bar {
    margin-left: 16px;
  }

  &__description {
    padding: 0 24px 16px 24px;
  }

  &__content {
    position: relative;

    &--with-divider::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: $av-border-width-sm;
      background-color: $av-brand-accent;
    }
  }

  &__footer {
    display: flex;
    padding: 0 24px 24px 24px;
  }
}
</style>
